import React, { useState, useEffect, useContext } from 'react';
import { useSiteData } from 'react-static';
import { ThemeContext } from 'styled-components';
// template components
import SectionVideoPlayer from '@nmx/template/dist/componentLibrary/modules/SectionVideoPlayer';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import backgroundImageDesktop from '../../../../../images/components/sectionVideoPlayer/family-playing-by-golden-gate-bridge.webp';
import backgroundImageTablet from '../../../../../images/components/sectionVideoPlayer/family-playing-by-golden-gate-bridge-tablet.webp';

export default () => {
  const { config } = useSiteData();

  const theme = useContext(ThemeContext);
  const largeDown = theme.largeDown();
  const [isLargeDown, setIsLargeDown] = useState(largeDown);

  useEffect(() => {
    if (largeDown !== isLargeDown) {
      setIsLargeDown(largeDown);
    }
  }, [largeDown, isLargeDown]);

  return (
    <SectionVideoPlayer
      backgroundImage={isLargeDown ? backgroundImageTablet : backgroundImageDesktop}
      config={config}
      playButtonSupportiveText='Watch the video'
      duration='1m 11s'
      durationDisplay='1 min'
      sectionId='financial-planning-video'
      videoId='qNdd9wW1Pq4'
      videoTitle='See how we can help you reach your financial goals'
      title={<>See how we can help you reach your financial goals <WidowBlock>with confidence.</WidowBlock></>}
    />
  );
};
